// extracted by mini-css-extract-plugin
module.exports = {"twin-spin":"TwinSpin_twin-spin__bp6yV","spin":"TwinSpin_spin__3Ns7r","pulse":"TwinSpin_pulse__v-3Kx"};